import gql from 'graphql-tag';

export const ContentPermissionsQuery = gql`
	query ContentPermissionsQuery($accountId: String!, $contentId: ID!) {
		contentPermissions(contentId: $contentId) {
			contentAccess
			subjectsWithEffectiveContentPermissions {
				edges {
					node {
						id
					}
				}
			}
		}
		userWithContentRestrictions(accountId: $accountId, contentId: $contentId) {
			hasSpaceViewPermission
			restrictingContent {
				id
				hasRestrictions
			}
		}
	}
`;
